/*if (document.getElementById('beeda-loader')) {
    window.addEventListener('load', function() {
      var loader = document.getElementById('beeda-loader');
      setTimeout(function() {
        fadeOut(loader, function() {
          if (document.getElementsByClassName('preloader-hidden').length > 0) {
            document.body.classList.remove('preloader-hidden');
          }
        });
      }, 350);
    });
  }
  
function fadeOut(element, callback) {
    var opacity = 1;
    var interval = setInterval(function() {
      if (opacity <= 0) {
        clearInterval(interval);
        element.style.display = 'none';
        if (typeof callback === 'function') {
          callback();
        }
      }
      element.style.opacity = opacity;
      opacity -= 0.1;
    }, 50);
}*/

if (document.getElementById('beeda-loader')) {
    window.addEventListener('load', function() {
      var loader = document.getElementById('beeda-loader');
      setTimeout(function() {
        loader.classList.add('fade-out');
        loader.addEventListener('transitionend', function() {
          if (document.getElementsByClassName('preloader-hidden').length > 0) {
            document.body.classList.remove('preloader-hidden');
          }
          loader.style.display = 'none';
        });
      }, 350);
    });
}
  